import React from "react";
import { Spin } from "antd";
import { cn } from "src/util/cn";

interface LoaderProps {
  height?: string;
  className?: string;
  size?: "small" | "default" | "large";
  tip?: string;
}

const Loader: React.FC<LoaderProps> = ({
  height = "h-screen",
  className,
  size = "default",
  tip = "Loading...",
}) => (
  <div className={cn("flex items-center justify-center flex-1", height, className)}>
    <Spin size={size} tip={tip} />
  </div>
);

export default Loader;
